module.exports = __webpack_public_path__ + "static/airport-large-d5d399668f33af91fa0f0a30cf9cb7d7.png";